"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _classnames2 = _interopRequireDefault(require("classnames"));

var _shortid = _interopRequireDefault(require("shortid"));

var _inputContainer = _interopRequireDefault(require("../input-container"));

var _inputLabel = _interopRequireDefault(require("../input-label"));

var _inputBar = _interopRequireDefault(require("../input-bar"));

var _inputHint = _interopRequireDefault(require("../input-hint"));

var _inputInput = _interopRequireDefault(require("../input-input"));

var _inputText = _interopRequireDefault(require("../input-text"));

var _inputMessage = _interopRequireDefault(require("../input-message"));

var _inputOption = _interopRequireDefault(require("../input-option"));

var _icon = _interopRequireDefault(require("../icon"));

var _excluded = ["ariaLabel", "checkmarkIcon", "children", "className", "containerProps", "contentAfterInput", "contentBeforeInput", "css", "disabled", "errorIcon", "errorText", "fullwidth", "expanded", "helpIcon", "helpText", "id", "inputContainerProps", "invalid", "label", "labelId", "noValidate", "onBlur", "onChange", "onFocus", "placeholder", "readOnly", "showCheckmark", "showErrorText", "showHelpText", "useNativePlaceholder"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var CSS_STATE = 'vds-state';
var Input = (0, _react.forwardRef)(function (_ref, ref) {
  var ariaLabel = _ref.ariaLabel,
      checkmarkIcon = _ref.checkmarkIcon,
      children = _ref.children,
      className = _ref.className,
      containerProps = _ref.containerProps,
      contentAfterInput = _ref.contentAfterInput,
      contentBeforeInput = _ref.contentBeforeInput,
      css = _ref.css,
      disabled = _ref.disabled,
      errorIcon = _ref.errorIcon,
      errorText = _ref.errorText,
      fullwidth = _ref.fullwidth,
      expanded = _ref.expanded,
      helpIcon = _ref.helpIcon,
      helpText = _ref.helpText,
      _ref$id = _ref.id,
      id = _ref$id === void 0 ? _shortid.default.generate() : _ref$id,
      inputContainerProps = _ref.inputContainerProps,
      invalid = _ref.invalid,
      label = _ref.label,
      labelId = _ref.labelId,
      noValidate = _ref.noValidate,
      onBlur = _ref.onBlur,
      onChange = _ref.onChange,
      onFocus = _ref.onFocus,
      placeholder = _ref.placeholder,
      readOnly = _ref.readOnly,
      showCheckmark = _ref.showCheckmark,
      showErrorText = _ref.showErrorText,
      showHelpText = _ref.showHelpText,
      useNativePlaceholder = _ref.useNativePlaceholder,
      remainingProps = _objectWithoutProperties(_ref, _excluded);

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      dirty = _useState2[0],
      setDirty = _useState2[1];

  var _useState3 = (0, _react.useState)(Boolean(remainingProps.value) || Boolean(remainingProps.defaultValue)),
      _useState4 = _slicedToArray(_useState3, 2),
      filled = _useState4[0],
      setFilled = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      focused = _useState6[0],
      setFocused = _useState6[1];

  var _useState7 = (0, _react.useState)(invalid),
      _useState8 = _slicedToArray(_useState7, 2),
      isInvalid = _useState8[0],
      setIsInvalid = _useState8[1];

  var uniqueId = (0, _react.useRef)(id);
  var uid = uniqueId.current;
  ref = ref || (0, _react.useRef)();

  var setValidity = function setValidity(e) {
    if (!noValidate) {
      if (dirty) {
        return setIsInvalid(!e.target.checkValidity() || e.target.required && !e.target.value.trim().length);
      }

      if (!dirty && e.target.required && !e.target.value.trim().length) {
        return setIsInvalid(true);
      }

      if (dirty && !e.target.required && !e.target.value.trim().length) {
        return setIsInvalid(undefined);
      }
    }
  };

  (0, _react.useEffect)(function () {
    setFilled(Boolean(remainingProps.defaultValue) || Boolean(remainingProps.value));
  }, [remainingProps.defaultValue, remainingProps.value]);
  (0, _react.useEffect)(function () {
    setIsInvalid(invalid);
  }, [invalid]);
  (0, _react.useEffect)(function () {
    if (ref && ref.current) {
      if (invalid && errorText) {
        ref.current.setCustomValidity(errorText);
      }

      if (!invalid) {
        ref.current.setCustomValidity('');
      }
    }
  }, [errorText, invalid, ref]);

  var handleBlur = function handleBlur(e) {
    setFocused(false);
    setValidity(e);

    if (typeof onBlur === 'function') {
      onBlur(e);
    }
  };

  var handleChange = function handleChange(e) {
    setFilled(e.target.value !== '');

    if (typeof isInvalid === 'boolean') {
      setValidity(e);
    }

    setDirty(true);

    if (typeof onChange === 'function') {
      onChange(e);
    }
  };

  var handleFocus = function handleFocus(e) {
    setFocused(true);

    if (typeof onFocus === 'function') {
      onFocus(e);
    }
  };

  return /*#__PURE__*/_react.default.createElement(_inputContainer.default, _extends({
    className: (0, _classnames2.default)(className),
    css: css,
    disabled: disabled,
    expanded: expanded,
    filled: filled,
    focus: focused,
    readOnly: readOnly,
    invalid: isInvalid
  }, containerProps), label ? /*#__PURE__*/_react.default.createElement(_inputLabel.default, {
    id: labelId,
    htmlFor: uid
  }, label) : undefined, /*#__PURE__*/_react.default.createElement(_inputBar.default, {
    className: (0, _classnames2.default)({
      'vds-input--fullwidth': fullwidth
    })
  }, /*#__PURE__*/_react.default.createElement(_inputInput.default, inputContainerProps, contentBeforeInput, placeholder && !useNativePlaceholder ? /*#__PURE__*/_react.default.createElement(_inputHint.default, null, placeholder) : undefined, /*#__PURE__*/_react.default.createElement(_inputText.default, _extends({
    "aria-describedby": "input-message-help-".concat(uid, " input-message-error-").concat(uid),
    "aria-label": label ? undefined : ariaLabel,
    "aria-invalid": isInvalid,
    id: uid,
    disabled: disabled,
    onBlur: handleBlur,
    onChange: handleChange,
    onFocus: handleFocus,
    placeholder: useNativePlaceholder ? placeholder : undefined,
    readOnly: readOnly,
    ref: ref
  }, remainingProps))), showCheckmark && typeof isInvalid === 'boolean' && !isInvalid && Boolean(checkmarkIcon) ? /*#__PURE__*/_react.default.createElement(_inputOption.default, {
    className: (0, _classnames2.default)(_defineProperty({}, "".concat(CSS_STATE, "--hidden"), typeof isInvalid === 'boolean' && isInvalid))
  }, checkmarkIcon) : undefined, contentAfterInput, children), /*#__PURE__*/_react.default.createElement(_inputMessage.default, {
    id: "input-message-help-".concat(uid),
    invalid: isInvalid,
    show: true
  }, !isInvalid && focused && showHelpText && Boolean(helpText) ? /*#__PURE__*/_react.default.createElement(_react.Fragment, null, helpIcon, " ", helpText) : ''), /*#__PURE__*/_react.default.createElement(_inputMessage.default, {
    id: "input-message-error-".concat(uid),
    invalid: isInvalid,
    show: true
  }, isInvalid === true && showErrorText && Boolean(errorText) ? /*#__PURE__*/_react.default.createElement(_react.Fragment, null, errorIcon, " ", errorText) : ''));
});
Input.propTypes = {
  /**
   * Aria Label
   */
  ariaLabel: _propTypes.string,

  /**
   *  Checkmark Icon
   */
  checkmarkIcon: _propTypes.node,

  /**
   * @ignore
   */
  children: _propTypes.node,

  /**
   * @ignore
   */
  className: _propTypes.string,

  /**
   * Container Props
   */
  containerProps: _propTypes.object,
  // eslint-disable-line

  /**
   * Content After input use for icons, etc
   */
  contentAfterInput: _propTypes.node,

  /**
   * Content Before input use for icons, etc
   */
  contentBeforeInput: _propTypes.node,

  /**
   * @ignore
   */
  css: _propTypes.func,

  /**
   * Disabled
   */
  disabled: _propTypes.bool,

  /**
   *  Error Message Icon
   */
  errorIcon: _propTypes.node,

  /**
   *  Error Message
   */
  errorText: _propTypes.node,

  /**
   *  Expanded
   */
  expanded: _propTypes.bool,

  /**
   * Removes Set Width on .vds-input-bar
   */
  fullwidth: _propTypes.bool,

  /**
   * Input Help Message Icon
   */
  helpIcon: _propTypes.node,

  /**
   * Input Help Message
   */
  helpText: _propTypes.node,

  /**
   * ID
   */
  id: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]),

  /**
   * Input Container Props, applies to .vds-input-text
   */
  inputContainerProps: _propTypes.object,
  // eslint-disable-line

  /**
   * Invalid
   */
  invalid: _propTypes.bool,

  /**
   * Label
   */
  label: _propTypes.node,

  /**
   * Label Id
   */
  labelId: (0, _propTypes.oneOfType)([_propTypes.number, _propTypes.string]),

  /**
   * Disable native HTML5 validation e.g. type=email, pattern="some regex pattern"
   */
  noValidate: _propTypes.bool,

  /**
   * Callback fired when the input element loses focus.
   */
  onBlur: _propTypes.func,

  /**
   * On Change
   */
  onChange: _propTypes.func,

  /**
   * Callback fired when the input element is focused on.
   */
  onFocus: _propTypes.func,

  /**
   * Placeholder
   */
  placeholder: _propTypes.node,

  /**
   * ReadOnly
   */
  readOnly: _propTypes.bool,

  /**
   * Show Checkmark Icon
   */
  showCheckmark: _propTypes.bool,

  /**
   * Show Error Message
   */
  showErrorText: _propTypes.bool,

  /**
   * Show Help Message
   */
  showHelpText: _propTypes.bool,

  /**
   * Use native placeholder
   */
  useNativePlaceholder: _propTypes.bool
};
Input.defaultProps = {
  checkmarkIcon: /*#__PURE__*/_react.default.createElement(_icon.default, {
    name: "checkmark",
    resolution: "low"
  }),
  errorIcon: /*#__PURE__*/_react.default.createElement(_icon.default, {
    name: "error",
    resolution: "tiny"
  })
};
Input.displayName = 'Input';
var _default = Input;
exports.default = _default;